// ADDITIVE: /dashboard/tasks entry. When the org has the Tasks module enabled
// (Organization.tasksEnabled, surfaced on the org profile) it mounts the isolated
// module from src/modules/tasks; otherwise it keeps rendering the legacy
// "Connect Jira / Asana" placeholder so nothing changes for other orgs.
// Revert = point the App.js routes back at pages/Goals/MyTasks.
import React, { Suspense, lazy } from 'react';
import MyTasks from '../Goals/MyTasks';
import { useOrgProfile } from '../DashboardV2/hooks/useOrgProfile';

const TasksModule = lazy(() =>
  import('../../modules/tasks').then((m) => ({ default: m.TasksModule }))
);

export default function TasksRoute() {
  const profile = useOrgProfile();
  const [on, setOn] = React.useState(() => profile?.tasksEnabled === true);
  React.useEffect(() => {
    if (profile?.tasksEnabled === true) setOn(true);
    else if (profile && profile.tasksEnabled === false) setOn(false);
  }, [profile]);
  if (on) {
    return (
      <Suspense fallback={<div style={{ padding: 32, color: "#888", fontSize: 13 }}>Loading Tasks…</div>}>
        <TasksModule />
      </Suspense>
    );
  }
  if (profile === undefined || profile === null) return null;
  return <MyTasks />;
}
